var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-item",class:{
    'has-icon': _vm.icon,
    'has-border': _vm.border
  },on:{"click":_vm.go}},[_c('div',{staticClass:"left"},[_vm._t("left")],2),_c('div',{staticClass:"right"},[_vm._t("right")],2),_c('img',{attrs:{"src":require("@/assets/next.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }